import React from 'react'
import { ModalBase, IModalBaseProps, MODAL_TYPES } from 'transfix-ui/components/Modals'
import { makeParserVersionLive } from './api'
import { ParserVersion, parserVersionRequest } from './types'

interface IMakeLiveConfirmationModalProps extends Omit<IModalBaseProps, 'modalType'> {
  onClose: () => void
  onSuccess: () => void
  onError: (error: string) => void
  currentParserVersion?: ParserVersion
}

export const MakeLiveConfirmationModal = ({
  currentParserVersion,
  onClose,
  onError,
  onSuccess,
  open = true,
  ...props
}: IMakeLiveConfirmationModalProps) => {
  const makeLive = async () => {
    const body: parserVersionRequest = {
      configurable_parser_version: {
        parser_library: currentParserVersion?.parser_library,
        stupidedi_config: currentParserVersion?.stupidedi_config,
        edi_mapper_tfx12_definition_id: currentParserVersion?.edi_mapper_tfx12_definition_id,
        extraction_template: currentParserVersion?.extraction_template,
        conversion_instructions: currentParserVersion?.conversion_instructions,
        element_conversion: currentParserVersion?.element_conversion,
        document_conversion: currentParserVersion?.document_conversion,
      },
    }

    try {
      await makeParserVersionLive(body, currentParserVersion?.id || 0)
      onSuccess()
      onClose()
    } catch (e) {
      onError(e)
      onClose()
    }
  }

  const actions: IModalBaseProps['actions'] = [
    {
      label: 'Make Live',
      action: () => {
        makeLive()
      },
      type: 'confirm',
      dataTest: 'confirm-button',
    },
    {
      label: 'Cancel',
      type: 'dismiss',
      dataTest: 'cancel-button',
    },
  ]

  return (
    <ModalBase
      onClose={onClose}
      dataTest='MakeLiveConfirmationModal'
      modalType={MODAL_TYPES.form}
      size={3}
      open={open}
      title='Make this parser version live?'
      actions={actions}
      {...props}
    />
  )
}
